import { c as _c } from "react/compiler-runtime";
import { Flex, Heading, HStack, IconButton, Image, VStack } from '@chakra-ui/react';
import { VideoLessonProgressBar } from '@src/components/sco/Education/VideoListDetail/VideoLessonProgressBar';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { VideoList, Video } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
import React from 'react';
import { BsPlayFill } from 'react-icons/bs';
type VideoLessonsListProps = {
  videoList: VideoList;
  videos: Video[];
};
export const VideoLessonsList = props => {
  const $ = _c(7);
  let t0;
  if ($[0] !== props.videoList || $[1] !== props.videos) {
    let t1;
    if ($[3] !== props.videoList) {
      t1 = video => <HStack key={video.id} bgColor="colorPalette.container" border="1px solid" borderColor="colorPalette.border" borderRadius="0.5em" boxShadow="base" direction={["column", "row"]} gap={4} padding={[4, 6]}><NextLink href={`/videos/${props.videoList.slug}/${video.slug}?play=1`}><Image bgColor="black" borderRadius="0.5em" src={video.featuredImage?.url} width="200px" /></NextLink><Flex direction="column" flexGrow={1} gap={2} width="full"><Heading size={["md", "lg"]}><NextLink href={`/videos/${props.videoList.slug}/${video.slug}?play=1`}>{video.title}</NextLink></Heading><VideoLessonProgressBar video={video} videoList={props.videoList} /></Flex><IconButton asChild={true} aria-label="Play video"><NextLink href={`/videos/${props.videoList.slug}/${video.slug}?play=1`}><BsPlayFill /></NextLink></IconButton></HStack>;
      $[3] = props.videoList;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    t0 = props.videos.map(t1);
    $[0] = props.videoList;
    $[1] = props.videos;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[5] !== t0) {
    t1 = <VStack align="stretch" gap="3" width="full">{t0}</VStack>;
    $[5] = t0;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
};
VideoLessonsList.fragments = {
  VideoLesson: () => gql`
    fragment _ on Video {
      id
      title
      slug
      durationInSeconds
      ${VideoLessonProgressBar}
    }
  `
};